// Holds the "a new version is waiting" state for UpdateBanner.
//
// serviceWorkerRegistration.js calls setWaiting(registration) through the
// onUpdate hook index.js passes in. UpdateBanner reads it with
// useSyncExternalStore and calls applyUpdate() when the user taps.
//
// Nothing here reloads on its own. The controllerchange listener that reloads
// is only added inside applyUpdate, so a worker that activates for any other
// reason (another tab updated, say) leaves this page alone and a form in
// progress is never lost.

let waitingRegistration = null;
let reloading = false;
const listeners = new Set();

export function setWaiting(registration) {
  waitingRegistration = registration;
  listeners.forEach((listener) => listener());
}

export function getWaiting() {
  return waitingRegistration;
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function reloadOnce() {
  if (reloading) return;
  reloading = true;
  window.location.reload();
}

export function applyUpdate() {
  const waiting = waitingRegistration && waitingRegistration.waiting;

  // The worker already took over (another tab tapped first). The new code is
  // active, so the user's tap only needs a reload to load it.
  if (!waiting) {
    reloadOnce();
    return;
  }

  reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', reloadOnce, { once: true });
  waiting.postMessage({ type: 'SKIP_WAITING' });
}
